import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useRef } from "react";
import * as Styled from "./style";
import { PcItems } from "~/components/blocks/vod/top/common/category-carousel/carousel/pc-items";
import { SpItems } from "~/components/blocks/vod/top/common/category-carousel/carousel/sp-items";
import { useCategoryCarousel } from "~/components/blocks/vod/top/common/category-carousel/hooks/use-category-carousel";
import type { Links } from "~/components/blocks/vod/top/hooks/use-set-link-data";
import { useMatchMedia } from "~/hooks/use-match-media";

type CarouselProps = {
  categories: Links;
  isVideoSubPage: boolean;
};

export const Carousel = ({ categories, isVideoSubPage }: CarouselProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const { isSpSize } = useMatchMedia();

  const { isShowPrevButton, isShowNextButton, onPrevButtonClicked, onNextButtonClicked } = useCategoryCarousel({
    ref,
    isSpSize,
  });

  return (
    <Styled.DivContainer isVideoSubPage={isVideoSubPage}>
      {isShowPrevButton && (
        <Styled.ButtonArrow
          type="button"
          isVideoSubPage={isVideoSubPage}
          name="prev-button"
          aria-label="prev-button"
          onClick={onPrevButtonClicked}
        >
          <Icon name="arrowLeft" size="XL" color="GRAY900" />
        </Styled.ButtonArrow>
      )}
      {isShowNextButton && (
        <Styled.ButtonArrow
          isRight
          isVideoSubPage={isVideoSubPage}
          type="button"
          name="next-button"
          aria-label="next-button"
          onClick={onNextButtonClicked}
        >
          <Icon name="arrowRight" size="XL" color="GRAY900" />
        </Styled.ButtonArrow>
      )}

      {/* カテゴリ表示 */}
      <Styled.DivWrapper ref={ref}>
        {isSpSize ? (
          <SpItems even={categories.filter((_, i) => i % 2 === 0)} odd={categories.filter((_, i) => i % 2 !== 0)} />
        ) : (
          <PcItems links={categories} />
        )}
      </Styled.DivWrapper>
    </Styled.DivContainer>
  );
};
